import IndonesiaMap from "../../Components/Maps/indonesiaMaps";

export default function MapsPage() {
  return (
    <section className="py-7 bg-white">
      <div className="text-center  flex flex-col justify-center">
        <h2 className="text-3xl md:text-4xl font-bold text-[#131010]">
          Region <span className="text-red-500 font-bilbo">Check</span>
        </h2>
        <p className="mt-2 text-xs md:text-sm max-w-xl mx-auto text-center text-gray-600 px-2">RegionCheck – Bantu Sesama. Pantau dan bantu wilayah yang membutuhkan. Uluran tangan Anda adalah energi bagi mereka untuk kembali bangkit.</p>
      </div>
      <div className="md:-mt-16">
        <IndonesiaMap />
      </div>
      {/* LEGEND */}
      <div className="flex gap-6 justify-center md:-mt-24 text-sm">
        <div className="flex items-center gap-2 ">
          <span className="w-4 h-4 bg-red-600 rounded"></span>
          kemiskinan
        </div>
        <div className="flex items-center gap-2">
          <span className="w-4 h-4 bg-yellow-400 rounded"></span>
          Bencana Alam
        </div>
      </div>
    </section>
  );
}
